import Button from 'shared/components/Button'
import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex: 1;

  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  padding: 10px;
`
export const Icon = styled.img`
  width: 70px;
  height: 70px;
`

export const Text = styled.p`
  font-weight: 700;
  font-size: 24px;
  color: ${colors.blue};
  text-align: center;
`
export const StyleButton = styled(Button)`
  margin-right: 15px;
`

export const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Logo = styled.img`
  padding: 15px;
`

export const Content = styled.div`
  margin: 15px;
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-top: 1px solid ${colors.black};

  & > div:first-of-type {
    margin-bottom: 5px;
  }
`

export const Ticket = styled.div`
  margin-top: 15px;
  padding: 15px 0;
  width: 300px;
  background: #fff9c4;
`
export const ContainerFooter = styled.div`
  display: flex;
  justify-content: space-between;
`
